"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageListCard = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const MiniProviderCard_1 = require("../MiniProviderCard");
exports.PageListCard = (0, styled_1.default)(MiniProviderCard_1.MiniProviderCard) `
  max-width: 250px;
`;
//# sourceMappingURL=MiniProviderCardPageList.styles.js.map